import React from "react"

const LineBreak = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="334"
      height="12.219"
      viewBox="0 0 334 12.219"
    >
      <g
        id="Feather_line"
        data-name="Feather line"
        transform="translate(487.997 -950.5) rotate(90)"
      >
        <line
          id="Line_15"
          data-name="Line 15"
          y1="124.003"
          transform="translate(957.5 153.997)"
          fill="none"
          stroke="#a85e36"
          strokeWidth="2"
        />
        <line
          id="Line_16"
          data-name="Line 16"
          y1="124.997"
          transform="translate(957.5 363)"
          fill="none"
          stroke="#a85e36"
          strokeWidth="2"
        />
        <ellipse
          id="Ellipse_13"
          data-name="Ellipse 13"
          cx="5.841"
          cy="5.841"
          rx="5.841"
          ry="5.841"
          transform="translate(951.038 290.453)"
          fill="#a85e36"
        />
        <ellipse
          id="Ellipse_14"
          data-name="Ellipse 14"
          cx="5.841"
          cy="5.841"
          rx="5.841"
          ry="5.841"
          transform="translate(951.038 339.95)"
          fill="#a85e36"
        />
        <path
          id="Polygon_9"
          data-name="Polygon 9"
          d="M7,0l7,12H0Z"
          transform="translate(950.5 328.497) rotate(-90)"
          fill="#a85e36"
        />
      </g>
    </svg>
  )
}

export default LineBreak
